<section class="location-form d-flex flex-column flex-wrap location-form">
  <ng-container [formGroup]="locationForm">
    <div class="location-form-wrapper">
      <mat-form-field class="form-column">
        <mat-label>Location Name</mat-label>
        <input
          matInput
          placeholder="Location Name"
          formControlName="location_name"
          required
        />
        @if (
          locationForm.get("location_name")?.hasError("required") ||
          locationForm.get("location_name")?.hasError("whitespace")
        ) {
          <mat-error>
            {{ ERROR_MSG.required }}
          </mat-error>
        }
        @if (
          locationForm.get("location_name")?.hasError("minLength") &&
          !locationForm.get("location_name")?.hasError("whitespace")
        ) {
          <mat-error> This field must contain at least 2 characters </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="form-column">
        <mat-label>Email</mat-label>
        <input
          matInput
          type="email"
          placeholder="Email"
          autocomplete="email"
          required
          formControlName="email"
        />
        @if (locationForm.get("email")?.hasError("required")) {
          <mat-error>
            {{ ERROR_MSG.required }}
          </mat-error>
        }
        @if (locationForm.get("email")?.hasError("pattern")) {
          <mat-error> Invalid email format </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="form-column">
        <mat-label>Address</mat-label>
        <input
          matInput
          placeholder="Address"
          formControlName="address"
          required
        />
        @if (
          locationForm.get("address")?.hasError("required") ||
          locationForm.get("address")?.hasError("whitespace")
        ) {
          <mat-error>
            {{ ERROR_MSG.required }}
          </mat-error>
        }
        @if (
          locationForm.get("address")?.hasError("minLength") &&
          !locationForm.get("address")?.hasError("whitespace")
        ) {
          <mat-error> This field must contain at least 2 characters </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="form-column">
        <mat-label>Phone #</mat-label>
        <input
          matInput
          [mask]="phoneNumberMask"
          [placeholder]="
            locationForm.get('phone_number')?.value ? 'Phone Number' : ''
          "
          formControlName="phone_number"
        />
        @if (locationForm.get("phone_number")?.invalid) {
          <mat-error> Invalid phone number format </mat-error>
        }
      </mat-form-field>
      <mat-form-field
        class="form-column mb-4"
        [class.disable-dropdown]="locationForm.get('timezone')?.disabled"
      >
        <mat-label>Time Zone</mat-label>
        <mat-select formControlName="timezone" required>
          @for (timeZone of utcList; track timeZone.id) {
            <mat-option [value]="timeZone.id">
              {{ timeZone.label }}
            </mat-option>
          }
        </mat-select>
        @if (locationForm.get("timezone")?.invalid) {
          <mat-error>
            {{ ERROR_MSG.required }}
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="form-column">
        <mat-label>Location Type</mat-label>
        <mat-select formControlName="location_type_id" required>
          @for (location of locationTypes$ | async; track location) {
            <mat-option [value]="location.location_type_id">
              {{ location.location_name }}
            </mat-option>
          }
        </mat-select>
        <mat-error>
          {{ ERROR_MSG.required }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="location-form-contact-wrapper">
      <div
        class="location-form-contact-name-wrapper d-flex align-items-center justify-content-between"
      >
        <div class="location-form-contact-name">Contact</div>

        <button class="white-button ml-3" (click)="addContact()">
          <mat-icon>add</mat-icon>
          Add Contact
        </button>
      </div>

      <div class="form-field-row mb-2">
        <mat-form-field
          class="mt-2 form-column"
          [floatLabel]="
            locationForm.get('contact_name')?.value ? 'auto' : 'always'
          "
        >
          <mat-label>Contact Name</mat-label>
          <input
            matInput
            [placeholder]="
              locationForm.get('contact_name')?.value ? 'Contact Name' : ''
            "
            formControlName="contact_name"
          />
          @if (
            locationForm.get("contact_name")?.hasError("minLength") ||
            locationForm.get("contact_name")?.hasError("whitespace")
          ) {
            <mat-error>
              This field must contain at least 2 characters
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field
          class="mt-2 form-column"
          [floatLabel]="
            locationForm.get('contact_email')?.value ? 'auto' : 'always'
          "
        >
          <mat-label>Contact Email</mat-label>
          <input
            matInput
            [placeholder]="
              locationForm.get('contact_email')?.value ? 'Contact Email' : ''
            "
            formControlName="contact_email"
          />
          @if (
            locationForm.get("contact_email")?.hasError("pattern") ||
            locationForm.get("contact_email")?.hasError("whitespace")
          ) {
            <mat-error> Invalid email format </mat-error>
          }
        </mat-form-field>
        <mat-form-field
          class="mt-2 form-column"
          [floatLabel]="
            locationForm.get('contact_phone_number')?.value ? 'auto' : 'always'
          "
        >
          <mat-label>Contact Phone #</mat-label>
          <input
            matInput
            [mask]="phoneNumberMask"
            [placeholder]="
              locationForm.get('contact_phone_number')?.value
                ? 'Contact Phone Number'
                : ''
            "
            formControlName="contact_phone_number"
          />
          @if (locationForm.get("contact_phone_number")?.invalid) {
            <mat-error> Invalid phone number format </mat-error>
          }
        </mat-form-field>
      </div>
    </div>
  </ng-container>
  <ng-container [formGroup]="extraContactsForm">
    <ng-container formArrayName="extra_contacts">
      @for (
        extraCont of extraContactsForm.get("extra_contacts")["controls"];
        track extraCont;
        let i = $index
      ) {
        <div
          class="align-items-center location-form-contact-wrapper"
          [formGroupName]="i"
        >
          <div
            class="location-form-contact-name-wrapper d-flex align-items-center justify-content-between"
          >
            <div class="location-form-contact-name">Contact</div>
            <button class="white-button ml-3" (click)="removeContact(i)">
              <mat-icon>remove</mat-icon>
              Remove Contact
            </button>
          </div>
          <mat-form-field
            class="form-column"
            [floatLabel]="
              extraCont.get('contact_name').value ? 'auto' : 'always'
            "
          >
            <mat-label>Contact Name</mat-label>
            <input
              matInput
              [placeholder]="
                extraCont.get('contact_name').value ? 'Contact Name' : ''
              "
              formControlName="contact_name"
            />
            @if (
              extraCont.get("contact_name").hasError("minLength") ||
              extraCont.get("contact_name").hasError("whitespace")
            ) {
              <mat-error>
                This field must contain at least 2 characters
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field
            class="form-column"
            [floatLabel]="
              extraCont.get('contact_email').value ? 'auto' : 'always'
            "
          >
            <mat-label>Contact Email</mat-label>
            <input
              matInput
              [placeholder]="
                extraCont.get('contact_email').value ? 'Contact Email' : ''
              "
              formControlName="contact_email"
            />
            @if (
              extraCont.get("contact_email").hasError("pattern") ||
              extraCont.get("contact_email").hasError("whitespace")
            ) {
              <mat-error> Invalid email format </mat-error>
            }
          </mat-form-field>
          <mat-form-field
            class="form-column"
            [floatLabel]="
              extraCont.get('contact_phone_number').value ? 'auto' : 'always'
            "
          >
            <mat-label>Contact Phone #</mat-label>
            <input
              matInput
              [mask]="phoneNumberMask"
              [placeholder]="
                extraCont.get('contact_phone_number').value
                  ? 'Contact Phone Number'
                  : ''
              "
              formControlName="contact_phone_number"
            />
            @if (extraCont.get("contact_phone_number").invalid) {
              <mat-error> Invalid phone number format </mat-error>
            }
          </mat-form-field>
        </div>
      }
    </ng-container>
  </ng-container>
</section>
